<template>
  <div>
    <div>
<!--       <button v-if="showVideo" @click="closeVideo();return false;">Video Kapat</button>
      <button v-if="showVirtualTour && !virtualShowOpened" @click="openVirtualTour();return false;">Sanal Tur</button>
      <button v-if="virtualShowOpened" @click="closeVirtualTour();return false;">Sanal Tur Kapat</button>
            <div ref="myvideo" id="video"></div> -->
      <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop" >
        <swiper-slide v-for="img in gallery" :key="img.height" >
          <div class="dormThumbWrapper">
            <img v-if="!img.key1" :src="'http://image.tmdb.org/t/p/w185/' + img.file_path" alt="" class="gallery-top__img" > 
            <img v-if="img.key" :src="'https://img.youtube.com/vi/' +  img.key + '/hqdefault.jpg'" alt="" class="gallery-top__img" v-on:click="myFunction1(img.key)" >

            <!-- If there is video show the icon -->
            <div class="videoIcon" v-if="hasVideo && img.site == 'YouTube'" v-on:click="myFunction1(img.key)">
              <img src="../assets/img/white-play-icon.jpg" alt="play icon">
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      </swiper>
      <!-- swiper2 Thumbs -->
      <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
        <swiper-slide v-for="img in gallery" :key="img.height">
          <img :src="'http://image.tmdb.org/t/p/w185/' + img.file_path" alt="" class="gallery-thumbs__img">
          <img v-if="img.key" :src="'https://img.youtube.com/vi/' +  img.key + '/hqdefault.jpg'" alt="" class="gallery-thumbs__img" >

        </swiper-slide>
      </swiper>
    </div>
 <Modal2 :active="showVideo" @onModalClose="closeModal">
   <div slot="content">
 <iframe width="800" height="600" class="ql-video" frameborder="0" allowfullscreen="true" :src="src"></iframe>    
</div>
</Modal2>
  </div>
</template>
<script>
import Modal2 from '@/components/Modal2'
export default {
  props: {
    gallery: Array,
    hasVideo: false,
  },
  components: {
    Modal2
  },  
  data () {
    return {
      src: '',
      showVideo: false,
      showGallery: true,
      player: '',
      swiperOptionTop: {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 5,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        slidesPerView: 6,
        touchRatio: 0.2,
        loop: true,
        loopedSlides: 5,
        slideToClickedSlide: true
      }
    }
  },
  methods: {
    closeModal() {
      this.showVideo = false
      // this.$refs.myvideo.innerHTML = '';
    },  
    closeVideo() {
      this.showGallery = true
      this.$refs.myvideo.innerHTML = '';
    },   
              myFunction1(filename) {
                this.src = 'https://www.youtube.com/embed/' + filename
              //    if (this.hasVideo && filename.includes('youtube')){
                    this.showVideo = true
              //  }
                //this.$refs.myvideo.innerHTML = '<iframe width="676" height="480" class="ql-video" frameborder="0" allowfullscreen="true" src=' + src?showinfo=0?autoplay=1"></iframe>';
                //this.showGallery = false
                // document.getElementById("video").innerHTML = "<div id='player'></div>";

                // 2. This code loads the IFrame Player API code asynchronously.
            },  
            myFunction() {
                this.$refs.myvideo.innerHTML = "<div id='player'></div>";
                // document.getElementById("video").innerHTML = "<div id='player'></div>";

                // 2. This code loads the IFrame Player API code asynchronously.
                var tag = document.createElement('script');

                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            },

            // 3. This function creates an <iframe> (and YouTube player)
            //    after the API code downloads.
            onYouTubeIframeAPIReady() {
                player = new YT.Player('player', {
                    height: '390',
                    width: '640',
                    videoId: 'a4XsqC_K4lg-VE',
                    events: {
                        'onReady': onPlayerReady,
                        'onStateChange': onPlayerStateChange
                    }
                });
            },           
  openVideo(filename) {
    
    if(filename.src) {
     // let src = window.localStorage.getItem('src')
      window.open(filename.src, '_blank')
    }
              }
  },
  mounted () {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper
      const swiperThumbs = this.$refs.swiperThumbs.swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  },
  created() {
    if(window.localStorage.getItem('src')) {
      this.src = window.localStorage.getItem('src')
    }
    // + '?showinfo=0?autoplay=1"
  }
}
</script>

<style lang="scss" scoped>
  .swiper-container {
    padding-bottom: 0 !important;
  }

  .swiper-slide {
    background-size: cover;
    background-position: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

  }

  .swiper-button-prev, .swiper-button-next {
    opacity: 0;
    transition: all 0.4s;
    padding: 17px;
    width: 58px;
    height: 58px;
    border-radius: 100%;
  }

  .gallery-top {
    border-radius: 12px;
    height: 550px;

    &:hover {
      .swiper-button-prev, .swiper-button-next {
        opacity: 1;
        transition: all 0.4s;

        &:hover {
          background-color: #00000054;
        }

      }
    }
  }

  .gallery-thumbs {
    box-sizing: border-box;
    margin-top: 15px;
    border-radius: 12px;
  }

  .gallery-thumbs .swiper-slide {
    width: 155px;
    height: 100px;
    opacity: 0.4;
    border-radius: 6px;

    img {
      border-radius: 6px;
    }

  }

  .gallery-thumbs .swiper-slide-active {
    opacity: 1;
  }

  .left-icon{
    position: absolute;
    z-index: 9;
    font-size: 34px !important;
    color: white;
    left: 17px;
    top: 14px;

  }
</style>
